import _                from 'lodash';
import pluralize        from 'pluralize';
import EntityCollection from './entity_collection';
import PaginationInfo   from './pagination_info';

export default class BackendResponse {
  constructor(response, model, associations, includedModels, pageNumber, pageSize) {
    this.response       = response;
    this.model          = model;
    this.associations   = associations;
    this.includedModels = includedModels;
    this.pageNumber     = pageNumber;
    this.pageSize       = pageSize;
    this.results        = this.response.results || this.response;
  }

  entity() {
    const entity = this._entityFor(this.model);

    if (entity && this.includedModels.length) {
      const primaryCollection = EntityCollection.singletonFor(entity, this.associations);

      return this._jointCollectionFor(primaryCollection).first();
    } else {
      return entity;
    }
  }

  collection() {
    const primaryCollection = this._collectionFor(this.model);

    let collection;

    if (this.includedModels.length) {
      collection = this._jointCollectionFor(primaryCollection);
    } else {
      collection = primaryCollection;
    }

    collection.pagination = new PaginationInfo(this.pageNumber, this.pageSize, this.response.count);

    return collection;
  }

  _jointCollectionFor(primaryCollection) {
    const joinReducer = (running, current) => running.join(current);

    return _.reduce(this._assocCollections(), joinReducer, primaryCollection);
  }

  _assocCollections() {
    return this.includedModels.map(model => this._collectionFor(model, false));
  }

  _entityFor(model) {
    return model.deserialize(this.response[_.snakeCase(model.name)]);
  }

  _collectionFor(model, primary = true) {
    const rows     = this._rowsFor(model, primary);
    const entities = rows.map(row => model.deserialize(row));

    return EntityCollection.for(entities, model, this.associations);
  }

  _rowsFor(model, primary = true) {
    const key      = _.snakeCase(pluralize(model.name));
    const assocKey = '+' + key;

    if (primary) {
      return this.results[key];
    } else {
      return _.concat(this.results[key] || [], this.results[assocKey] || []);
    }
  }
}
